import React from 'react'
import Search from './services/Search'
import SortBy from './components/SortBy'
import ItemCard from './components/ItemCard/ItemCard'

const EMPTY_STATES = {
  'my-watches': {
    icon: 'fal fa-heart',
    title: 'No watched lots yet',
    body: 'Tap the heart on any lot to save it here and follow the bidding.'
  },
  'currently-winning': {
    icon: 'fal fa-trophy',
    title: "You're not winning any lots",
    body: 'Place a bid to take the lead and support a great cause.'
  },
  'my-outbids': {
    icon: 'fal fa-gavel',
    title: "No outbids",
    body: "Lots where you've been outbid will appear here — jump back in before they close."
  }
}

class MyCbPage extends React.Component {
  constructor(props) {
    super(props)

    const filters = new Search().initFilters({})

    this.state = {
      lots: [],
      loading: true,
      filters,
      hide_qty_sort: true
    }

    this.changeState = this.changeState.bind(this)
    this.search = this.search.bind(this)
    this.fetchLots = this.fetchLots.bind(this)
  }

  componentDidMount() {
    this.fetchLots()
  }

  fetchLots(params = {}) {
    const { category_id } = this.props
    this.setState({ loading: true })
    axios.get(`/categories/${category_id}/catalog_items.json`, { params })
      .then(resp => {
        const lots = resp.data.data.catalog_items.map(c => c.v2)
        this.setState({ lots, loading: false })
      })
      .catch(() => {
        this.setState({ loading: false })
      })
  }

  changeState(newState) {
    this.setState(newState)
  }

  search({ m }) {
    const model = m || this.state
    const [sort_by, sort_direction] = model.filters.sort_by.query.code.split(':')
    this.fetchLots({ sort_by, sort_direction })
  }

  emptyState() {
    const { category_id } = this.props
    const { icon, title, body } = EMPTY_STATES[category_id] || {
      icon: 'fal fa-search',
      title: 'No results',
      body: ''
    }

    return (
      <div style={{ textAlign: 'center', padding: '80px 24px' }}>
        <i className={icon} style={{ fontSize: '52px', color: '#d0d0d0', display: 'block', marginBottom: '20px' }} />
        <h3 style={{ fontSize: '20px', fontWeight: '600', color: '#222', marginBottom: '10px' }}>{title}</h3>
        <p style={{ fontSize: '15px', color: '#888', maxWidth: '340px', margin: '0 auto 28px', lineHeight: '1.5' }}>{body}</p>
        <a href="/" style={{
          display: 'inline-block',
          padding: '11px 28px',
          background: '#1a1a1a',
          color: '#fff',
          borderRadius: '3px',
          textDecoration: 'none',
          fontSize: '13px',
          letterSpacing: '0.8px',
          textTransform: 'uppercase',
          fontWeight: '500'
        }}>
          Browse Lots
        </a>
      </div>
    )
  }

  render() {
    const { lots, loading } = this.state
    const lot_count = lots.length

    return (
      <div>
        {loading ? (
          <div className="loading filter-item small cell small-12 text-center" style={{ padding: '60px 0' }}>
            <div className="ico-loading la-ball-clip-rotate-multiple la-2x" aria-hidden="true">
              <div></div>
              <div></div>
            </div>
          </div>
        ) : lot_count === 0 ? (
          this.emptyState()
        ) : (
          <div>
            <div className="simple-filters-wrapper grid-x">
              <div className="filter-item small cell small-12 medium-4 large-offset-8">
                <div className="filter-sort f-sort-list">
                  <SortBy model={this.state} changeState={this.changeState} search={this.search} />
                </div>
              </div>
            </div>
            <div className="lot-cards grid-x grid-margin-x">
              {lots.map((lot, i) => {
                const pos = i + 1
                const meta = { lot_count, pos, page: 1, keyword: 'MyCbPage', showIntro: pos === 1 }
                return <ItemCard item={lot} meta={meta} key={lot.id} />
              })}
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default MyCbPage
